import { InputBase, styled } from '@mui/material'
import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { colorPalette } from '../../../../style/colorPalette'
import { useDebouncedTextInput } from './useDebouncedTextInput'

type TextCellProps = {
  value: string | undefined
  onChange?: (v: string | undefined) => void
  onBlur?: () => void
  onCompositionStart?: () => void
  onCompositionEnd?: () => void
} & CellPropsBase
export const TextCell = ({
  label,
  help,
  tooltip,
  placeholder,
  cellWidth,
  value,
  onChange,
  onCompositionStart,
  onCompositionEnd,
  editable = true,
  required = false,
  edited,
  validationErrors,
}: TextCellProps) => {
  const { inputValue, onChangeInput } = useDebouncedTextInput(value, onChange)

  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea
        edited={edited}
        validationErros={validationErrors}
        tooltip={tooltip}
      >
        <TextInput
          value={inputValue}
          onChange={onChangeInput}
          disabled={!editable}
          placeholder={placeholder}
          onCompositionStart={onCompositionStart}
          onCompositionEnd={onCompositionEnd}
        />
      </CellValueArea>
    </FormCell>
  )
}

const TextInput = styled(InputBase)({
  width: '100%',
  '& .MuiInputBase-input.Mui-disabled': {
    color: colorPalette.monotone[3],
    '-webkit-text-fill-color': colorPalette.monotone[3],
  },
})
